module.exports = __webpack_public_path__ + "static/img/10bg_6.be30e41.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_6.png
// module id = 613
// module chunks = 1